import { Contact } from '@/business/message/models/contact'
import { NumberMap } from '@/shared/utils/map'

export interface MessageBox {
  contacts: Contact[]
  contactMap: NumberMap<Contact>
}

export const EmptyMessageBox: MessageBox = {
  contacts: [],
  contactMap: {},
}
